import React, { useEffect, useRef, useCallback, useState } from "react";
import { useLocation,Link } from "react-router-dom";
import PropTypes from "prop-types";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "../../components/Common/withRouter";

import { hasPermission } from "../../helpers/permission";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = (props) => {

  const [counts, setCounts] = useState({
  unreadCustomers: 0,
  unreadCarts: 0,
  unreadOrders: 0,
  unreadTickets: 0
});
  const ref = useRef();
  const baseurl = process.env.REACT_APP_BASE_URL;
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }

    
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  useEffect(() => {

  const fetchCounts = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("authUser"));
      const response = await fetch(
        `${baseurl}/admin/dashboard/dashboard?user_id=${user.id}`
      );

      const data = await response.json();

      setCounts({
        unreadCustomers: data.unreadCustomers || 0,
        unreadCarts: data.unreadCarts || 0,
        unreadOrders: data.unreadOrders || 0,
        unreadTickets: data.unreadTickets || 0
      });
    } catch (error) {
      console.log(error);
    }
  };

  fetchCounts();

  const interval = setInterval(fetchCounts, 5000);

  return () => clearInterval(interval);
}, []);

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {hasPermission("dashboard.dashboard.view") && (
            <li>
              <Link to="/">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
            </li>
            )}

            {hasPermission("subadmin.subadmin.view") && (
            <li>
              <Link to="/manage-sub-admin-users">
                <i className="bx bx-user-circle"></i>
                <span>{props.t("Manage Sub Admin Users")}</span>
              </Link>
            </li>
            )}

            {(hasPermission("master.display_name.view") || 
            hasPermission("master.certificate.view") || 
            hasPermission("master.brand.view") || 
            hasPermission("master.category.view") || 
            hasPermission("master.subcategory.view") || 
            hasPermission("master.subsubcategory.view") || 
            hasPermission("master.role.view")) && (

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-cog"></i>
                <span>{props.t("Manage Master")}</span>
              </Link>
              <ul className="sub-menu">
                {hasPermission("master.display_name.view") && (
                <li>
                  <Link to="/manage-master/display-name">
                    - {props.t("Display Name")}
                  </Link>
                </li>
                )}
                {hasPermission("master.certificate.view") && (
                <li>
                  <Link to="/manage-master/certificate">
                    - {props.t("Certificate")}
                  </Link>
                </li>
                )}
                {hasPermission("master.brand.view") && (
                <li>
                  <Link to="/manage-master/brand">- {props.t("Brand")}</Link>
                </li>
                )}
                {hasPermission("master.category.view") && (
                <li>
                  <Link to="/manage-master/categories">
                    - {props.t("Categories")}
                  </Link>
                </li>
                )}
                {hasPermission("master.subcategory.view") && (
                <li>
                  <Link to="/manage-master/sub-categories">
                    - {props.t("Sub Categories")}
                  </Link>
                </li>
                )}
                {hasPermission("master.subsubcategory.view") && (
                <li>
                  <Link to="/manage-master/sub-sub-categories">
                    - {props.t("Sub Sub-Categories")}
                  </Link>
                </li>
                )}
                {hasPermission("master.role.view") && (
                <li>
                  <Link to="/manage-master/role">- {props.t("Role")}</Link>
                </li>
                )}
              </ul>
            </li>
            )}

            {hasPermission("media.media.view") && (
            <li>
              <Link to="/media-upload">
                <i className="bx bx-image-add"></i>
                <span>{props.t("Media Gallery")}</span>
              </Link>
            </li>
            )}

            {hasPermission("products.products.view") && (
            <li>
              <Link to="/manage-products">
                <i className="bx bx-basket"></i>
                <span>{props.t("Manage Products")}</span>
              </Link>
            </li>
            )}
            {(hasPermission("inward.online_store.view") || 
            hasPermission("inward.offline_warehouse.view")) && (

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-store-alt"></i>
                <span>{props.t("Manage Inward")}</span>
              </Link>
              <ul className="sub-menu">
                {hasPermission("inward.online_store.view") && (
                <li>
                  <Link to="/manage-inventory/display">
                    - {props.t("Online Store")}
                  </Link>
                </li>
                 )}
                {hasPermission("inward.offline_warehouse.view") && (
                <li>
                  <Link to="/manage-inventory/reserved">
                    - {props.t("Offline Warehouse")}
                  </Link>
                </li>
                 )}
                
              </ul>
            </li>
             )}
            {(hasPermission("customers.individual.view") || 
            hasPermission("customers.corporate.view")) && (


            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-group"></i>
                
                <span>{props.t("Manage Customer")}</span>
                {counts.unreadCustomers > 0 && (
                  <span className="badge rounded-pill bg-danger" style={{ marginLeft: "5px" }}>
                    {counts.unreadCustomers}
                  </span>
                )}
                
              </Link>
              <ul className="sub-menu">
                {hasPermission("customers.individual.view") && (
                <li>
                  <Link to="/manage-customers/individual">
                    - {props.t("Individual")}
                  </Link>
                </li>
                )}
                {hasPermission("customers.corporate.view") && (
                <li>
                  <Link to="/manage-customers/corporate">
                    - {props.t("Corporate")}
                  </Link>
                </li>
                )}
              </ul>
            </li>
            )}
            {(hasPermission("carts.individual_customers.view") || 
            hasPermission("carts.corporate_customers.view")) && (


            <li>
              <Link to="/#" className="has-arrow ">
                    
                    <i className="bx bx-basket"></i>
                    
                    <span>{props.t("Manage Carts")}</span>
                    {counts.unreadCarts > 0 && (
                      <span className="badge rounded-pill bg-danger" style={{ marginLeft: "10px" }} >
                        {counts.unreadCarts}
                      </span>
                    )}
                  </Link>
                  <ul className="sub-menu">
                    {hasPermission("customers.individual.view") && (
                    <li>
                      <Link to="/manage-request/cart/individual-customers">
                        - {props.t("Individual Customers")}
                      </Link>
                    </li>
                    )}
                    {hasPermission("customers.corporate.view") && (
                    <li>
                      <Link to="/manage-request/cart/corporate-customers">
                        - {props.t("Corporate Customers")}
                      </Link>
                    </li>
                    )}
                  </ul>
            </li>
            )}


            {(hasPermission("requests.bom.view") || 
            hasPermission("requests.product_requests.view") || 
            hasPermission("requests.contact_request.view")) && (

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-list-ul"></i>
                <span>{props.t("Manage Requests")}</span>
              </Link>
              <ul className="sub-menu">
                {hasPermission("requests.bom.view") && (
                
                <li>
                  <Link to="/manage-request/bom">
                    - {props.t("BOM - (Bill of Materials)")}
                  </Link>
                </li>
                )}
                    {hasPermission("requests.product_requests.view") && (
                <li>
                  <Link to="/manage-request/new-product">
                    - {props.t("Product Requests")}
                  </Link>
                </li>
                )}
                    {hasPermission("requests.contact_request.view") && (
                <li>
                  <Link to="/manage-request/contact">
                    - {props.t("Contact Request")}
                  </Link>
                </li>
                )}
              </ul>
            </li>
            )}
            {hasPermission("tickets.tickets.view") && (
            
            <li>
              <Link to="/manage-ticket">
                <i className="bx bx-barcode"></i>
                
                <span>{props.t("Manage Ticket")}</span>
                {counts.unreadTickets > 0 && (
                  <span className="badge rounded-pill bg-danger" style={{ float: "right" }} >
                    {counts.unreadTickets}
                  </span>
                )}
              </Link>
            </li>
            )}
            {(hasPermission("contents.blogs.view") ||
            hasPermission("contents.banner.view") || 
            hasPermission("contents.legal.view")) && (
            

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-image"></i>
                <span>{props.t("Manage Contents")}</span>
              </Link>
              <ul className="sub-menu">
                {hasPermission("contents.blogs.view") && (
            
                <li>
                  <Link to="/manage-contents/blogs">- {props.t("Blogs")}</Link>
                </li>
                )}
            
                {hasPermission("contents.banner.view") && (
            
                <li>
                  <Link to="/manage-contents/banner">
                    - {props.t("Banner")}
                  </Link>
                </li>
                )}
            
                {hasPermission("contents.legal.view") && (
            
                <li>
                  <Link to="/manage-contents/legal">- {props.t("Legal")}</Link>
                </li>
                )}
            
              </ul>
            </li>
            )}
            
            {(hasPermission("orders.corporate.view") ||
            hasPermission("orders.individual.view"))  && (
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-detail" />
                 
                <span>{props.t("Manage Orders")}</span>
                {counts.unreadOrders > 0 && (
      <span className="badge rounded-pill bg-danger" style={{ marginLeft: "10px" }}>
        {counts.unreadOrders}
      </span>
    )}
              </Link>
              <ul className="sub-menu">
                {hasPermission("orders.corporate.view") && (
            
                <li>
                  <Link to="/manage-orders/corporate-customer">
                    - {props.t("Corporate")}
                  </Link>
                </li>
                )}
            
                {hasPermission("orders.individual.view") && (
            
                <li>
                  <Link to="/manage-orders/individual-customer">
                    - {props.t("Individual")}
                  </Link>
                </li>
                )}
            
              </ul>
            </li>
            )}
            
            {hasPermission("reports.reports.view") && (
            

            <li>
              <Link to="/generate-reports">
                <i className="bx bxs-report"></i>
                <span>{props.t("Generate Reports")}</span>
              </Link>
            </li>
            )}
            
            {hasPermission("shipping.shipping.view") && (
            
            <li>
              <Link to="/shipping-charge">
                <i className="bx bxs-ship"></i>
                <span>{props.t("Shipping Charge")}</span>
              </Link>
            </li>
            )}
            
            {hasPermission("settings.settings.view") && (
            
            <li>
              <Link to="/settings">
                <i className="bx bx-cog"></i>
                <span>{props.t("Settings")}</span>
              </Link>
            </li>
            )}
            
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
